@use "ui/styles/sizes";
@use "ui/styles/effects";
@use "ui/styles/fonts";
@use "ui/styles/colors";

.wrapper {
    display: flex;
    align-items: center;
    gap: sizes.$s4;
    width: fit-content;
    font-size: var(--switch-size, fonts.$base);
    --switch-background-color: #{colors.$gray30};

    .root {
        &[data-state="checked"] {
            --switch-background-color: var(--primary-color);
            box-shadow: inset var(--switch-border-shadow), inset 0 0.5px 2.5px 0 rgba(102, 102, 102, 0.75);

            .thumb {
                transform: translateX(1.33em);
            }
        }
    }

    // Hover states
    &.clickable {
        .root {
            cursor: pointer;
        }

        &:hover .root {
            --switch-border-shadow: 0 0 0 1.5px var(--primary-color);
        }
    }

    // Disabled state
    &.disabled {
        .root {
            opacity: 0.4;
            cursor: not-allowed;
        }
    }

    &.small {
        --switch-size: #{fonts.$small};
    }
}

.root {
    transition: all 200ms ease-in;
    border-radius: effects.$borderRadiusL;
    height: 1.5em;
    width: 2.75em;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    border: none;
    background-color: var(--switch-background-color);
    --switch-border-shadow: 0 0 0 1.5px transparent;
    box-shadow: inset var(--switch-border-shadow), inset 0 0.5px 1.5px 0 rgba(0, 0, 0, 0.12), inset 0 0 1px 0 rgba(0, 0, 0, 0.02);
    padding: 0;
    cursor: default;

    &:focus-visible {
        outline: 2px solid var(--focus-ring);
        outline-offset: 2px;
    }
}

.thumb {
    display: block;
    width: 1.3125em;
    height: 1.3125em;
    border-radius: 50%;
    transition: all 100ms ease-in;
    will-change: transform;
    transform: translateX(0.1em);
    background-color: colors.$brandWhite;
    border: 0.5px solid rgba(0, 0, 0, 0.02);
    box-shadow: 0 0.5px 1px 0.25px rgba(0, 0, 0, 0.12);
}
